<template>
  <div id="app">
    <Navigation></Navigation>

    <!-- <Test></Test> -->

    <router-view/>
    
    <Copyright></Copyright>
  </div>
</template>

<style>
/* Vue 默认 */
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-decoration: none;
}
</style>

<script>
  import Navigation from "./components/Navigation";
  import Copyright from "./components/Copyright";
  import Test from "./components/Test";
  export default {
    components: {
        Navigation,
        Copyright,
        Test,
    },
  };
</script>